import type { ReactNode } from "react";

import { Box } from "@/design-system/Box";
import { Card } from "@/design-system/Card";
import { ContentBlock } from "@/design-system/ContentBlock";

export function OnboardingFlowRoot({ children }: { children: ReactNode }): ReactNode {
  return <div className="flex min-h-screen flex-col">{children}</div>;
}

export function OnboardingFlowHeader({ brand, action }: { brand: ReactNode; action: ReactNode }): ReactNode {
  return (
    <header className="@container z-sticky shrink-0 border-b border-border-default bg-background-secondary px-space-md">
      <nav className="mx-auto flex h-flow-header max-w-content-flow-header items-center justify-between gap-space-md">
        {brand}
        {action}
      </nav>
    </header>
  );
}

export function OnboardingFlowBrandMark({ children }: { children: ReactNode }): ReactNode {
  return <span className="size-icon-display">{children}</span>;
}

export function OnboardingFlowContent({ children }: { children: ReactNode }): ReactNode {
  return (
    <main className="@container z-raised flex w-full justify-center overflow-auto p-space-md">
      <ContentBlock width="flow" align="center">
        <Card as="section">{children}</Card>
      </ContentBlock>
    </main>
  );
}

export function OnboardingFlowActions({ children }: { children: ReactNode }): ReactNode {
  return <Box padding={{ top: "md" }}>{children}</Box>;
}
